export const APP_LINK_GOOGLE =
  'https://play.google.com/store/apps/details?id=com.inckd.tattoo'
export const APP_LINK_APPLE = 'https://apps.apple.com/us/app/inckd/id1526690381'

export const FACEBOOK_PROFILE_LINK = 'https://www.facebook.com/inckdcom/'
export const INSTAGRAM_PROFILE_LINK = 'https://www.instagram.com/inckd_com/'
export const LINKEDIN_PROFILE_LINK = 'https://www.linkedin.com/company/inckd'
